module.exports = __webpack_public_path__ + "img/flag-ger.5bda5f42.png";